import {
  CEE90,
  CEE500,
  RPC3_S250,
  CE_EBOX_251,
  RPC3_S125,
  PHG_P510K0L,
  PHG_ESS_5L_20L,
  CES556H201,
  CES430H201,
  DC_EV_CHARGER,
  CE_TITAN_V3,
  CE_TITAN_V4,
  MOBILE_ENERGY_STORAGE_VEHICLE,
} from '@/assets/img/new-product'
import { ProductCategory, ProductTag } from '@/assets/content/products/enum'

interface NavChild {
  title?: string
  items: { label: string; link?: string }[]
  viewMoreLink?: string
}

interface SubMenuContent {
  leftTitle?: string
  leftItems?: string[] // 左边纯文本列表
  centerTitle?: string
  centerProducts?: { name: string; image?: string; link?: string }[]
  centerViewMoreLink?: string
  rightTitle?: string
  rightItems?: string[]
}

interface NavItem {
  key: string
  label: string
  link?: string
  submenu?: SubMenuContent
}

export const navItems = [
  {
    key: 'home',
    label: 'Home',
    link: '/',
  },
  {
    key: 'product-solution',
    label: 'Products&Solution',
    submenu: {
      // leftTitle: '产品分类',
      leftTabs: [
        { key: 'commercial-energy-storage-systems', label: ProductCategory.CommercialEnergyStorageSystems },
        { key: 'residential-energy-storage-systems', label: ProductCategory.ResidentialEnergyStorageSystems },
        { key: 'centralized-pv-storage-systems', label: ProductCategory.CentralizedPVStorageSystems },
        {
          key: 'distributed-pv-storage-systems',
          label: ProductCategory.DistributedPVStorageSystems,
        },
        {
          key: 'specialty-mobile-power-systems',
          label: ProductCategory.SpecialtyMobilePowerSystems,
        },
      ],
      centerByTab: {
        'commercial-energy-storage-systems': [
          {
            category: ProductTag.ESS,
            products: [
              { name: 'Carus-CEE90', path: '/product-template/carus-cee90', image: CEE90 },
              { name: 'Carus-CEE500', path: '/product-template/carus-cee500', image: CEE500 },
              { name: 'CE-eBox-251', path: '/product-template/ce-e-box-251', image: CE_EBOX_251 },
              { name: 'RPC3-S125', path: '/product-template/rpc3-s125', image: RPC3_S125 },
              { name: 'RPC3-S250', path: '/product-template/rpc3-s250', image: RPC3_S250 },
            ],
          },
        ],
        'residential-energy-storage-systems': [
          {
            category: ProductTag.Inverter,
            products: [
              {
                name: 'PhG-P5K0~10K0LNA-M',
                path: '/product-template/phg-p510k0lna-m',
                image: PHG_P510K0L,
              },
            ],
          },
          {
            category: ProductTag.ESS,
            products: [
              { name: 'CE-eBox-251', path: '/product-template/ce-e-box-251', image: CE_EBOX_251 },
              { name: 'PHG-ESS-5L-20L', path: '/product-template/phg-ess-5l-20l', image: PHG_ESS_5L_20L },
            ],
          },
        ],
        'centralized-pv-storage-systems': [
          {
            category: ProductTag.ESS,
            products: [
              {
                name: 'CES430H201',
                path: '/product-template/ces430h201',
                image: CES430H201,
              },
              {
                name: 'CES556H201',
                path: '/product-template/ces556h201',
                image: CES556H201,
              },
              {
                name: 'E500',
                path: '/product-template/carus-cee500',
                image: CEE500,
              },
            ],
          },
        ],
        'distributed-pv-storage-systems': [
          {
            category: ProductTag.PV,
            products: [
              {
                name: 'CE-Titan V3',
                path: '/product-template/ce-titan-v3',
                image: CE_TITAN_V3,
              },
              {
                name: 'CE-Titan V4',
                path: '/product-template/ce-titan-v4',
                image: CE_TITAN_V4,
              },
              {
                name: 'DC EV Charger',
                path: '/product-template/dc-ev-charger',
                image: DC_EV_CHARGER,
              },
            ],
          },
          {
            category: ProductTag.ESS,
            products: [
              { name: 'Carus-CEE90', path: '/product-template/carus-cee90', image: CEE90 },
              { name: 'Carus-CEE500', path: '/product-template/carus-cee500', image: CEE500 },
              { name: 'CE-eBox-251', path: '/product-template/ce-e-box-251', image: CE_EBOX_251 },
              { name: 'RPC3-S125', path: '/product-template/rpc3-s125', image: RPC3_S125 },
              { name: 'RPC3-S250', path: '/product-template/rpc3-s250', image: RPC3_S250 },
            ],
          },
        ],
        'specialty-mobile-power-systems': [
          {
            category: '',
            products: [
              {
                name: 'Mobile Energy Storage Vehicle',
                path: '/product-template/mobile-energy-storage-vehicle',
                image: MOBILE_ENERGY_STORAGE_VEHICLE,
              },
            ],
          },
        ],
      },
      rightByTab: {
        'commercial-energy-storage-systems': [
          {
            name: 'Medical Renewable Energy',
            path: '/solution/medical-solution',
          },
        ],
        'residential-energy-storage-systems': [
          {
            name: 'Residential Renewable Energy',
            path: '/solution/renewable-energy',
          },
        ],
        'centralized-pv-storage-systems': [
          {
            name: 'Idle Land：Green Power Plant',
            path: '/solution/green-power-plant',
          },
        ],
        'distributed-pv-storage-systems': [
          {
            name: 'Green City Solution',
            path: '/solution/green-city',
          },
          {
            name: 'School Bus Replacement With Charging Facility Solution',
            path: '/solution/school-bus',
          },
        ],
        'specialty-mobile-power-systems': [
          // {
          //   name: 'Environmental Construction and Hazardous Removal',
          // },
          // {
          //   name: 'General Construction',
          // },
          // {
          //   name: 'Flooring and Waterproofing',
          // },
          // {
          //   name: 'Disaster Relief and Restoration',
          // },
          {
            name: 'Carus Disaster Relief ESS Solution',
            path: '/solution/disaster-relief',
          },
        ],
      },
    },
  },
  {
    key: 'service',
    label: 'Services&Support',
    link: '/service',
    submenu: {
      centerByTab: [
        {
          category: 'Services',
          products: [
            { name: 'Carbon Management', path: 'https://www.carusg-carbon.com' },
            { name: 'AI & Data Analytics', path: '/ai' },
          ],
        },
        {
          category: 'Support',
          products: [
            { name: 'Added Value Services', path: '/service-support' },
            { name: 'Project Financing Options', path: '/service-support' },
          ],
        },
      ],
    },
  },
  {
    key: 'news',
    label: 'Insights',
    link: '/news',
    submenu: {
      centerByTab: [
        {
          category: 'news&blog',
          products: [
            { name: 'Government Policies & Regulations' },
            { name: 'Carbon Neutrality & Emissions Reduction' },
            { name: 'Clean Energy Initiatives' },
          ],
        },
      ],
    },
  },
  {
    key: 'carus-ai',
    label: 'Carus AI',
    link: 'https://www.carusai.com',
  },
  {
    key: 'about-us',
    label: 'About Us',
    link: '/about-us',
  },
  {
    key: 'contact',
    label: 'Contact Us',
    link: '/contact',
  },
]
